import { ModulesConfig } from './subconfig/modulesConfig';

/**
 * Konfiguracja aplikacji
 *
 * @export
 * @class Config
 */
export class Config {
  /**
   * Tytuł aplikacji
   *
   * @type {string}
   * @memberof Config
   */
  public applicationTitle: string;
  /**
   * URL api GraphQL
   *
   * @type {string}
   * @memberof Config
   */
  public graphQLURL: string;

  /**
   * URL api medii
   *
   * @type {string}
   * @memberof Config
   */
  public mediaURL: string;

  /**
   * URL Api csv
   *
   * @type {string}
   * @memberof Config
   */
  public csvURL: string;

  /**
   * URL api map
   *
   * @type {string}
   * @memberof Config
   */
  public mapsURL: string;

  /**
   * URL kafelków mapy
   *
   * @type {string}
   * @memberof Config
   */
  public mapTilesURL: string;

  /**
   * Konfiguracja modułów
   *
   * @type {ModulesConfig}
   * @memberof Config
   */
  public modules: ModulesConfig;

  constructor() {
    this.applicationTitle = process.env.VUE_APP_TITLE as string;
    this.graphQLURL = process.env.VUE_APP_API_URL as string;
    this.mediaURL = process.env.VUE_APP_MEDIA_URL as string;
    this.csvURL = this.graphQLURL.replace('/graphql', '/csv');
    this.mapsURL = process.env.VUE_APP_MAPS_URL as string;
    this.mapTilesURL = process.env.VUE_APP_MAP_TILES_URL as string;
    this.modules = new ModulesConfig();
  }
}

export const config = new Config();
